import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  User,
  UserBaseInfo,
  UserEdit,
  UserRegister,
  UserResponse,
} from '../../shared/models/users.models';

@Injectable({
  providedIn: 'root',
})
export default class UsersService {
  private http = inject(HttpClient);

  getAllUsers(page?: number, search?: string): Observable<[User[], number]> {
    const params: string[] = [];
    if (page) {
      params.push(`page=${page}`);
    }

    if (search) {
      params.push(`search=${search.trim()}`);
    }

    return this.http.get<[User[], number]>(`/auth/users?${params.join('&')}`);
  }

  createUser(userDetails: UserRegister): Observable<UserResponse> {
    return this.http.post<UserResponse>('/auth/users', userDetails);
  }

  getUser(userId: string): Observable<UserResponse> {
    return this.http.get<UserResponse>(`/auth/users/${userId}`);
  }

  editUser(userId: string, userData: UserEdit): Observable<void> {
    return this.http.patch<void>(`/auth/users/${userId}`, { userData });
  }

  deleteUser(userId: string): Observable<boolean> {
    return this.http.delete<boolean>('/auth/users', { body: { id: userId } });
  }

  forceLogout(userId: string): Observable<void> {
    return this.http.post<void>('/auth/forceLogout', { userId });
  }

  getQaUsers(): Observable<UserBaseInfo[]> {
    return this.http.get<UserBaseInfo[]>('/auth/users/qa');
  }

  getQaManagers(): Observable<UserBaseInfo[]> {
    return this.http.get<UserBaseInfo[]>('/auth/users/qa-managers');
  }

  getShiftManagers(): Observable<UserBaseInfo[]> {
    return this.http.get<UserBaseInfo[]>('/auth/users/shift-managers');
  }

  getUsersByEmails(emails: string[]): Observable<UserBaseInfo[]> {
    return this.http.post<UserBaseInfo[]>('/auth/users/emails', emails);
  }

  getUsersByIds(ids: string[]): Observable<UserBaseInfo[]> {
    return this.http.post<UserBaseInfo[]>('/auth/users/ids', ids);
  }

  getUsersByDepartment(department: string): Observable<User[]> {
    return this.http.get<User[]>(`/auth/users/department/${department}`);
  }

  getUsersByScope(scope: string): Observable<UserBaseInfo[]> {
    return this.http.get<UserBaseInfo[]>(`/auth/users/scopes/${scope}`);
  }
}
